import React from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import Chip from '@material-ui/core/Chip';
import MaterialTable from 'material-table';
import moment from 'moment';
import { Query } from 'react-apollo';
import Spin from 'components/common/Spin';
import Select from 'components/form/Select';
import { useMutation, useQuery } from '@apollo/react-hooks';
import {
  GET_ADMIN_STUDENTS,
  UPDATE_STUDENT_PROFILE,
} from 'graphql/admin/students';
import { GET_USERS, UPDATE_USER } from 'graphql/admin/users';
import { REMOVE_STUDENT } from 'graphql/groups';
import { resetPassword } from 'utils/admin.service';
import useSnack from 'hooks/useSnack';
import PRODUCTS from 'constant/product-types';
import { Button } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { API } from 'aws-amplify';

const PRODUCTS_LOOKUP = PRODUCTS.reduce((memo, i) => {
  memo[i.value] = i.label;
  return memo;
}, {});



const RenderSelectCoach = ({ type, onChange, value }) => {
  return (
    <Query
      query={GET_USERS}
      variables={{ user_type: type, includeChildren: false }}
    >
      {({ data }) => {
        if (!data) return <Spin spinning />;


        const options = data.users.map((i) => ({
          label: `${i.user_first_name} ${i.user_last_name}`,
          value: i.user_id,
        }));
        return (
          <Select
            isMulti={false}
            style={{ width: 150 }}
            options={options}
            value={options.find((i) => i.value === value)}
            onChange={(v) => onChange(v.value)}
          />
        );
      }}
    </Query>
  );
};

const RenderSelectAdmin = ({ onChange, value }) => {
  return (
    <Query
      query={GET_USERS}
      variables={{ user_type: 'admin', includeChildren: false }}
    >
      {({ data }) => {
        if (!data) return <Spin spinning />;
        const options = data.users.map((i) => ({
          label: `${i.user_first_name} ${i.user_last_name}`,
          value: i.user_id,
        }));
        return (
          <Select
            isMulti={false}
            style={{ width: 150 }}
            options={options}
            value={options.find((i) => i.value === value)}
            onChange={(v) => onChange(v.value)}
          />
        );
      }}
    </Query>
  );
};

function pluck_gradYear(array, key) {
  return array?.students.map(o => o[key]);
}

const AdminStudents = ({ history }) => {
  const snack = useSnack();
  const user = useSelector((s) => s.user.user);
  const [updateMutation] = useMutation(UPDATE_STUDENT_PROFILE);
  const [updateUser] = useMutation(UPDATE_USER);
  const [removeGroupStudent] = useMutation(REMOVE_STUDENT);
  const { data, refetch } = useQuery(GET_ADMIN_STUDENTS, {
    fetchPolicy: 'cache-and-network',
  });


  let gradYear = pluck_gradYear(data, 'graduation_year');
  let unique_gradYear = [...new Set(gradYear)];
  let filtered_gradYear = unique_gradYear.filter((el) => el !== null);
  const YEAR_OPTIONS = filtered_gradYear.map((i) => ({ label: i, value: i }));
  var newObj = YEAR_OPTIONS.reduce((obj, item) => (obj[item.label] = item.value, obj), {})

  const [showPrompt, togglePrompt] = React.useState(false);
  const [username, setUsername] = React.useState();
  const [confirmationText, setconfirmationText] = React.useState();

  const handlePromptOpen = (event, user) => {
    event.stopPropagation()
    togglePrompt(true);
    setUsername(user.user_email);
  };

  const deleteUser = async () => {
    if (confirmationText === username) {
      try {
        await API.post('api', `/admin/user/delete/${username}`);
        snack.success('User successfully deleted');
        togglePrompt(false);
      } catch (e) {
        snack.error(e.message);
      }
    }
    else {
      snack.error('Emails do not match');
    }
  };

  const handlePromptClose = () => {
    togglePrompt(false);
  };

  const columns = [
    {
      title: 'Product',
      field: 'product_type',
      render: (row) =>
        row.product_type && (
          <Chip
            variant={'outlined'}
            label={PRODUCTS_LOOKUP[row.product_type]}
            color="primary"
            size="small"
          />
        ),
      lookup: PRODUCTS_LOOKUP,
      filtering: false,
    },
    {
      title: 'Graduation year',
      field: 'graduation_year',
      type: 'number',
      lookup: newObj,
      filterPlaceholder: "Select Year",
      filterOnItemSelect: true

    },

    {
      title: 'Group',
      field: 'group_student.group.name',
      editComponent: ({ rowData, ...other }) =>
        rowData.group_student && (
          <Chip
            size="small"
            variant={'outlined'}
            color={'secondary'}
            label={rowData.group_student.group.name}
            onDelete={() => removeFromGroup(rowData, other)}
          />
        ),
      filtering: false,
    },
    { title: 'Username', field: 'user_cognito_username', editable: 'never', filtering: false, },
    { title: 'Preferred Name', field: 'user_preferred_name', editable: 'never', filtering: false, },
    { title: 'First Name', field: 'user_first_name', editable: 'never', defaultSort: 'asc', filtering: false, },
    { title: 'Last Name', field: 'user_last_name', editable: 'never', filtering: false, },
    { title: 'User Email', field: 'user_email', editable: 'never', filtering: false, },
    { title: 'MBG date', field: 'mbg_date', type: 'date', filtering: false, },
    {
      title: 'Admin ID',
      field: 'admin_id',
      editComponent: (props) => {
        return <RenderSelectAdmin {...props} />;
      },
      filtering: false,
    },
    {
      title: 'CC ID',
      field: 'lc_id',
      editComponent: (props) => {
        return <RenderSelectCoach {...props} type="lead_coach" />;
      },
      filtering: false,
    },
    { title: 'College Coach', field: 'lc_name', editable: 'never', filtering: false, },

    {
      title: 'HC ID',
      field: 'hc_id',
      editComponent: (props) => {
        return <RenderSelectCoach {...props} type="head_coach" />;
      },
      filtering: false,
    },
    { title: 'Head Counselor', field: 'hc_name', editable: 'never', filtering: false, },

    {
      title: 'FA ID',
      field: 'fa_id',
      editComponent: (props) => {
        return <RenderSelectCoach {...props} type="fa_coach" />;
      },
      filtering: false,
    },
    { title: 'FA Counselor', field: 'fa_name', editable: 'never', filtering: false, },
    {
      title: 'Last Login',
      field: 'last_login_at',
      type: 'date',
      editable: 'never',
      filtering: false,
    },
    { title: 'User Id', field: 'user_id', type: 'numeric', editable: 'never', filtering: false, },
    { title: 'Status', field: 'user_status', editable: 'never', filtering: false, },
    {
      title: 'Trial',
      field: 'is_trial',
      type: 'boolean',
      filtering: false,
    },
    {
      title: 'Trial End',
      field: 'trial_end_date',
      type: 'date',
      filtering: false,
    },
    {
      title: 'Program End',
      field: 'subscriptions.0.end_date',
      type: 'date',
      editable: 'never',
      filtering: false,
    },
  ];

  const onUpdate = async (newData, oldData) => {
    let profileUpdateData;
    let updated = false;

    if (newData.lc_id !== oldData.lc_id) {
      profileUpdateData = {
        lc_id: newData.lc_id,
      };
    }
    if (newData.hc_id !== oldData.hc_id) {
      profileUpdateData = profileUpdateData || {};
      profileUpdateData.hc_id = newData.hc_id;
    }
    if (newData.fa_id !== oldData.fa_id) {
      profileUpdateData = profileUpdateData || {};
      profileUpdateData.fa_id = newData.fa_id;
    }
    if (oldData.product_type !== newData.product_type) {
      profileUpdateData = profileUpdateData || {};
      profileUpdateData.product_type = newData.product_type;
      if (oldData.product_type === 'group' && oldData.group_student) {
        await removeGroupStudent({
          variables: {
            id: oldData.group_student?.id,
            userId: oldData.user_id,
            roomId: oldData.group_student?.group?.room_id,
            convoId: oldData.group_student?.group?.sms_conversation_id,
          },
        });
      }
    }

    if (newData.trial_end_date !== oldData.trial_end_date) {
      profileUpdateData = profileUpdateData || {};
      profileUpdateData.trial_end_date = moment(newData.trial_end_date).format(
        'YYYY-MM-DD',
      );
    }

    if (newData.is_trial !== oldData.is_trial) {
      profileUpdateData = profileUpdateData || {};
      profileUpdateData.is_trial = newData.is_trial;
    }

    if (newData.admin_id !== oldData.admin_id) {
      profileUpdateData = profileUpdateData || {};
      profileUpdateData.admin_id = newData.admin_id;
    }
    if (newData.graduation_year !== oldData.graduation_year) {
      profileUpdateData = profileUpdateData || {};
      profileUpdateData.graduation_year = newData.graduation_year;
    }

    if (newData.mbg_date !== oldData.mbg_date) {
      profileUpdateData = profileUpdateData || {};
      profileUpdateData.mbg_date = newData.mbg_date;
    }

    if (profileUpdateData) {
      await updateMutation({
        variables: {
          userId: newData.user_id,
          data: profileUpdateData,
        },
      });

      updated = true;
    }

    if (updated) refetch();
  };

  const onResetPassword = async (e, data) => {
    if (window.confirm('Are you sure?')) {
      return resetPassword(data.user_cognito_username)
        .then(() => snack.success('Password updated.'))
        .catch((e) => snack.error(e.message));
    }
  };

  const onDelete = (data) => {
    return updateUser({
      variables: {
        userId: data.user_id,
        data: {
          deleted: true,
          deleted_by: user.id,
          deleted_at: new Date().toJSON(),
        },
      },
    })
      .then(() => refetch())
      .catch((e) => snack.error(e.message));
  };

  const removeFromGroup = (row, props) => {
    row.group_student = null;
    props.onRowDataChange(row);
  };

  if (!data) return <Spin spinning linear />;

  return (
    <React.Fragment>
      <Helmet title="Students" />
      <MaterialTable
        title="Students"
        columns={columns}
        data={data.students}
        editable={{
          onRowUpdate: onUpdate,
          onRowDelete: onDelete,
        }}
        actions={[
          {
            icon: 'visibility',
            tooltip: 'View',
            onClick: (event, rowData) =>
              history.push(`/students/${rowData.user_id}/timeline`),
          },
          {
            icon: () => <DeleteForeverIcon disabled={user.id != process.env.REACT_APP_ADMIN_ID} />,
            tooltip: 'Delete permanently',
            onClick: (event, rowData) => handlePromptOpen(event, rowData),
            disabled: user.id != process.env.REACT_APP_ADMIN_ID
          },
          {
            icon: 'videocam',
            tooltip: 'Open conference room',
            onClick: (e, rowData) =>
              window.open(
                rowData.group_student
                  ? `/meeting/group/${rowData.group_student?.group.id}`
                  : `/meeting/${rowData.user_cognito_sub}`,
              ),
          },
          {
            icon: 'lock',
            tooltip: 'Reset password',
            onClick: onResetPassword,
          },
        ]}
        options={{
          pageSize: 10,
          filtering: true,
          
        }}
      />
      {showPrompt && (
        <Dialog
          open={prompt}
          onClose={handlePromptClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Are you sure ?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              This will delete the user permanently.
            </DialogContentText>
            <TextField
              value={confirmationText}
              onChange={(e) => setconfirmationText(e.target.value)}
              autoFocus
              margin="dense"
              id="name"
              label="Type email address of user to confirm"
              type="email"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePromptClose}>Cancel</Button>
            <Button variant="contained" onClick={deleteUser} color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </React.Fragment>
  );
};

export default AdminStudents;
